const toBudgetAmount = (value) => Number(value || 0);

export const mergeBudgetSummary = (currentSummary, nextSummary) => {
  if (nextSummary === null) {
    return null;
  }

  const merged = {
    ...(currentSummary || {}),
    ...(nextSummary || {}),
  };

  const totalBudgetAmount = Number(merged.totalBudgetAmount || 0);
  const consumedBudgetAmount = Number(merged.consumedBudgetAmount || 0);
  const remainingBudgetAmount = Number(merged.remainingBudgetAmount || 0);

  return {
    ...merged,
    totalBudgetAmount,
    consumedBudgetAmount,
    remainingBudgetAmount,
    boostEventCount:
      merged.boostEventCount === undefined || merged.boostEventCount === null
        ? merged.boostEventCount
        : Number(merged.boostEventCount),
    consumedRate:
      totalBudgetAmount > 0
        ? Number(((consumedBudgetAmount / totalBudgetAmount) * 100).toFixed(1))
        : null,
  };
};

export const combineBudgetSourceRows = (baseRows, boostRows) => [
  ...(Array.isArray(baseRows) ? baseRows : []),
  ...(Array.isArray(boostRows) ? boostRows : []),
];

export const summarizeBudgetSourceRows = (rows) => {
  return (Array.isArray(rows) ? rows : []).reduce(
    (acc, row) => {
      acc.totalBudgetAmount += toBudgetAmount(row?.budgetAmount ?? row?.totalBudgetAmount);
      acc.consumedBudgetAmount += toBudgetAmount(row?.usedAmount ?? row?.consumedBudgetAmount);
      acc.remainingBudgetAmount += toBudgetAmount(row?.remainingAmount ?? row?.remainingBudgetAmount);
      return acc;
    },
    {
      totalBudgetAmount: 0,
      consumedBudgetAmount: 0,
      remainingBudgetAmount: 0,
    }
  );
};

export const composeBudgetSummary = (baseSummary, boostSourceRows, boostEventCount) => {
  const base = baseSummary || null;
  const boostTotals = summarizeBudgetSourceRows(boostSourceRows);
  const totalBudgetAmount = toBudgetAmount(base?.totalBudgetAmount) + boostTotals.totalBudgetAmount;
  const consumedBudgetAmount = toBudgetAmount(base?.consumedBudgetAmount) + boostTotals.consumedBudgetAmount;
  const remainingBudgetAmount = toBudgetAmount(base?.remainingBudgetAmount) + boostTotals.remainingBudgetAmount;
  const hasBaseSummary = Boolean(base);
  const hasBoostTotals =
    boostTotals.totalBudgetAmount > 0 ||
    boostTotals.consumedBudgetAmount > 0 ||
    boostTotals.remainingBudgetAmount > 0;

  if (!hasBaseSummary && !hasBoostTotals && boostEventCount === undefined) {
    return null;
  }

  return {
    ...(base || {}),
    totalBudgetAmount,
    consumedBudgetAmount,
    remainingBudgetAmount,
    boostEventCount:
      boostEventCount !== undefined
        ? boostEventCount
        : base?.boostEventCount,
    consumedRate:
      totalBudgetAmount > 0
        ? Number(((consumedBudgetAmount / totalBudgetAmount) * 100).toFixed(1))
        : null,
    bySourceRows: base?.bySourceRows || [],
  };
};

